/**
 * API functions for notification system
 */
import { fetcher } from '../utils/fetcher';
import type {
  NotificationCounts,
  NotificationPreference,
  NotificationPreferenceCreate,
  NotificationPreferenceUpdate,
} from '../types/notification';

const NOTIFICATION_URL = '/api/v1/notification-preferences';

export const getNotificationCounts = async (): Promise<NotificationCounts> => {
  return await fetcher(`${NOTIFICATION_URL}/counts`);
};

export const getNotificationPreferences = async (): Promise<NotificationPreference> => {
  return await fetcher(`${NOTIFICATION_URL}/read`);
};

export const createNotificationPreferences = async (
  data: NotificationPreferenceCreate
): Promise<NotificationPreference> => {
  return await fetcher(`${NOTIFICATION_URL}/create`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
};

export const updateNotificationPreferences = async (
  data: NotificationPreferenceUpdate
): Promise<NotificationPreference> => {
  return await fetcher(`${NOTIFICATION_URL}/update`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
};

export const testUpcomingNotification = async (): Promise<{
  success: boolean;
  message: string;
  task_count: number;
}> => {
  return await fetcher(`${NOTIFICATION_URL}/test/upcoming`);
};

export const testOverdueNotification = async (): Promise<{
  success: boolean;
  message: string;
  task_count: number;
}> => {
  return await fetcher(`${NOTIFICATION_URL}/test/overdue`);
};
